import React from "react";
import { Stethoscope } from "lucide-react";
import { Link } from "react-router-dom";

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen bg-neu-bg flex flex-col">
      <header className="max-w-7xl mx-auto w-full px-6 md:px-10 py-6 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <div className="w-11 h-11 rounded-xl bg-neu-accent flex items-center justify-center shadow-lg shadow-neu-accent/30">
            <Stethoscope className="w-6 h-6 text-white" />
          </div>
          <div>
            <div className="heading text-xl leading-none">FellowLog</div>
            <div className="text-xs subtle mt-1">Surgical case log</div>
          </div>
        </Link>
      </header>
      <main className="flex-1 flex items-center justify-center px-6 py-10">
        <div className="w-full max-w-md">
          <div className="neu-card p-8 md:p-10">
            <h1 className="heading text-3xl md:text-4xl text-[#3F4E5B]">{title}</h1>
            {subtitle && <p className="text-sm subtle mt-2">{subtitle}</p>}
            <div className="mt-8">{children}</div>
          </div>
          {footer && (
            <div className="text-center text-sm subtle mt-6">{footer}</div>
          )}
        </div>
      </main>
    </div>
  );
}

export function GoogleAuthButton({ testId = "google-auth-btn" }) {
  const start = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href =
      "https://auth.emergentagent.com/?redirect=" + encodeURIComponent(redirectUrl);
  };
  return (
    <button
      type="button"
      onClick={start}
      className="btn-neu w-full flex items-center justify-center gap-3"
      data-testid={testId}
    >
      <svg width="18" height="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path fill="#EA4335" d="M12 5.6c1.63 0 3.09.56 4.24 1.66l3.15-3.15C17.44 2.15 14.98 1 12 1 7.28 1 3.2 3.7 1.24 7.63l3.68 2.86C5.86 7.61 8.68 5.6 12 5.6z"/>
        <path fill="#4285F4" d="M23 12.24c0-.79-.07-1.55-.2-2.28H12v4.32h6.19c-.27 1.43-1.08 2.65-2.29 3.47l3.53 2.74C21.53 18.31 23 15.55 23 12.24z"/>
        <path fill="#FBBC05" d="M4.92 14.47c-.21-.63-.33-1.29-.33-1.97s.12-1.34.33-1.97L1.24 7.63C.45 9.11 0 10.79 0 12.5s.45 3.39 1.24 4.87l3.68-2.9z"/>
        <path fill="#34A853" d="M12 24c3.24 0 5.96-1.07 7.94-2.91l-3.53-2.74c-.98.66-2.24 1.06-4.41 1.06-3.32 0-6.14-2.01-7.08-4.89l-3.68 2.9C3.2 20.3 7.28 24 12 24z"/>
      </svg>
      Continue with Google
    </button>
  );
}
